import { Pipe, PipeTransform, inject } from '@angular/core';
import { TDurationUnit } from '@utilities/duration-utilities.interface';
import { DurationUtilitiesService } from '@utilities/duration-utilities.service';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  private readonly durationUtilitiesService = inject(DurationUtilitiesService);

  public transform(value: number | null, unit: TDurationUnit = 'minutes'): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    return this.durationUtilitiesService.getDuration(value, unit);
  }
}
